<template>
  <b-modal
    id="modal-catequista"
    ref="modal-catequista"
    size="xl"
    body-classes="p-0"
    @show="show"
    @hide="hide"
  >
    <b-form>
      <div>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre"
              placeholder="Nombre"
              :disabled="esVisible"
              v-model="catequista.nombre"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Primer apellido"
              placeholder="Primer apellido"
              :disabled="esVisible"
              v-model="catequista.apellido1"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Segundo apellido"
              placeholder="Segundo apellido"
              :disabled="esVisible"
              v-model="catequista.apellido2"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="date"
              label="Fecha de Nacimiento"
              locale="es"
              :disabled="esVisible"
              v-model="catequista.fecha_nacimiento"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Numero de telefono"
              placeholder="Numero de telefono"
              :disabled="esVisible"
              v-model="catequista.telefono"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Profesión"
              placeholder="Profesión"
              :disabled="esVisible"
              v-model="catequista.profesion"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Correo electronico"
              placeholder="Correo electronico"
              :disabled="esVisible"
              v-model="catequista.correoElectronico"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Dirección"
              placeholder="Dirección"
              :disabled="esVisible"
              v-model="catequista.direccion"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Notas"
              placeholder="Notas"
              :disabled="esVisible"
              v-model="catequista.notas"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="guardaCatequista()"
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "formularioCatequistas",
  components: {},
  props: ["datosCatequista"],
  data() {
    return {
      catequista: {
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        telefono: undefined,
        profesion: undefined,
        correoElectronico: undefined,
        direccion: undefined,
        notas: undefined,
      },
      esVisible: false,
    };
  },
  methods: {
    show() {
      this.catequista = {
        nombre: this.datosCatequista.nombre,
        apellido1: this.datosCatequista.apellido1,
        apellido2: this.datosCatequista.apellido2,
        fecha_nacimiento: this.datosCatequista.fecha_nacimiento,
        telefono: this.datosCatequista.telefono,
        profesion: this.datosCatequista.profesion,
        correoElectronico: this.datosCatequista.correoElectronico,
        direccion: this.datosCatequista.direccion,
        notas: this.datosCatequista.notas,
      };
    },
    hide() {
      this.catequista = {
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        telefono: undefined,
        profesion: undefined,
        correoElectronico: undefined,
        direccion: undefined,
        notas: undefined,
      };
      this.esVisible = false;
    },
    guardaCatequista() {
      if (this.datosCatequista) {
        this.datosCatequista.nombre = this.catequista.nombre;
        this.datosCatequista.apellido1 = this.catequista.apellido1;
        this.datosCatequista.apellido2 = this.catequista.apellido2;
        this.datosCatequista.fecha_nacimiento = this.catequista.fecha_nacimiento;
        this.datosCatequista.telefono = this.catequista.telefono;
        this.datosCatequista.profesion = this.catequista.profesion;
        this.datosCatequista.correoElectronico = this.catequista.correoElectronico;
        this.datosCatequista.direccion = this.catequista.direccion;
        this.datosCatequista.notas = this.catequista.notas;
        this.$emit("guardaCatequista", this.datosCatequista);
      } else {
        this.$emit("guardaCatequista", this.catequista);
      }
    },
  },
};
</script>
<style></style>
